{
  "overview": {
    "title": "Commande d'Infrastructure",
    "description": "Orchestration du calcul souverain, des clusters de données distribués et de l'épine dorsale de connectivité nationale. Gouvernance de maillage de classe institutionnelle.",
    "system": "CORE_INFRA",
    "badge": "RÉSEAU ACTIF",
    "deep_scan": "Scan Approfondi Actif",
    "initiate_audit": "Initier l'Audit",
    "system_health": "Santé du Système",
    "uptime": "Disponibilité",
    "compute_load": "Charge de Calcul",
    "threat_level": "Niveau de Menace",
    "database_clusters": "Grille de Données Distribuée",
    "database_clusters_desc": "Moteur de synchronisation de données de classe institutionnelle pour les clusters souverains.",
    "sync_status": "Statut de Sync",
    "global_iops": "IOPS Globaux",
    "cluster_count": "Nombre de Clusters",
    "nominal": "NOMINAL",
    "cyber_command": "Commandement Cyber",
    "cyber_command_desc": "Système de défense multi-couches en temps réel avec atténuation automatisée des menaces.",
    "encryption": "Chiffrement",
    "active_guards": "Gardes Actifs",
    "mesh_connectivity": "Connectivité Maillée",
    "mesh_connectivity_desc": "Routage haute performance à travers le réseau souverain.",
    "global_latency": "Latence Globale",
    "throughput": "Débit",
    "edge_nodes": "Nœuds de Bord",
    "identity_matrix": "Matrice d'Identité (CRM)",
    "identity_matrix_desc": "Moteur de gestion des relations approfondies avec contrôle d'accès institutionnel.",
    "registry_size": "Taille du Registre",
    "kyc_verified": "Vérifié KYC",
    "auth_success": "Succès Auth",
    "continuity_engine": "Moteur de Continuité",
    "continuity_engine_desc": "Système de sauvegarde géo-redondant avec réplication sous-milliseconde.",
    "dr_readiness": "Disponibilité DR",
    "sync_drift": "Dérive de Sync",
    "cold_storage": "Stockage à Froid",
    "certified": "CERTIFIÉ",
    "active": "ACTIF",
    "core_telemetry": "Télémétrie de Base",
    "hardware_pulse": "Pouls Matériel",
    "configure_grid": "Configurer la Grille",
    "aggregate_performance": "Performance Agrégée",
    "realtime_balancing": "Équilibrage de Charge",
    "window_24h": "Fenêtre 24h",
    "live_monitoring": "Surveillance en Direct",
    "timeline_24h": "Chronologie T-24H",
    "incident_command_log": "Journal de Commandement",
    "forensic_telemetry": "Télémétrie Forensique",
    "archives": "Archives",
    "secure_session": "Session Sécurisée • Charikaty Souverain",
    "warning": "Avertissement",
    "neural_compute_load": "Charge de Calcul Neuronal",
    "matrix_memory": "Mémoire Matricielle",
    "io_flux": "Flux E/S",
    "command_view": "Vue de Commande",
    "status_nominal": "Nominal",
    "status_warning": "Avertissement"
  },
  "security": {
    "title": "Sécurité Souveraine",
    "description": "Surveillance périmétrique de niveau ministériel et audit forensique en temps réel.",
    "system": "OPS_SÉCURITÉ",
    "audit_flow": "Flux d'Audit",
    "stress_test": "Test de Charge",
    "threat_surface": "Surface de Menace",
    "aggregated_risk_exposure": "Exposition Globale au Risque",
    "cryptographic_load": "Charge Cryptographique",
    "hsm_cluster_capacity": "Capacité Cluster HSM",
    "vault_sync_status": "Statut Sync Coffre",
    "multi_zone_consistency": "Cohérence Multi-Zone",
    "identity_trust": "Confiance d'Identité",
    "biometric_zero_trust": "Zéro Confiance Biométrique",
    "tabs": {
      "overview": "APERÇU",
      "encryption": "CHIFFREMENT",
      "access": "ACCÈS",
      "logs": "JOURNAUX"
    },
    "realtime_forensic_feed": "Flux Forensique en Temps Réel",
    "institutional_audit": "Audit Institutionnel",
    "live_transaction_stream": "Flux de Transactions en Direct",
    "system_live": "SYSTÈME_EN_DIRECT",
    "nodes_checked": "Nœuds Vérifiés : 100%",
    "trust_index": "Indice de Confiance",
    "perimeter_grid": "Grille Périmétrique",
    "ministerial_surveillance": "Surveillance Ministérielle",
    "global_anomaly_vector": "Vecteur d'Anomalie Global",
    "breach_identified": "VIOLATION_IDENTIFIÉE",
    "nominal_stable": "NOMINAL_STABLE",
    "lock_high_gates": "Verrouiller les Portes Hautes",
    "cycle_perimeter": "Périmètre de Cycle",
    "institutional_forensic_log": "Journal Forensique Institutionnel",
    "ministerial_access_system_traces": "Accès Ministériel & Traces Système",
    "master_archives": "Archives Principales",
    "view_trace": "Voir la Trace",
    "entropy_optimization": "Optimisation de l'Entropie",
    "multi_source_randomness_generation": "Génération d'Aléatoire Multi-Source",
    "master_key_rotation_verified": "Rotation des Clés Maîtresses Vérifiée",
    "sources": {
      "a": "Source A (HSM)",
      "b": "Source B (Quantique)",
      "c": "Source C (Dorsale)",
      "aggregated": "Pool Agrégé"
    },
    "bits_h": "Bits/H",
    "module_archive": "ARCHIVE DU MODULE",
    "scanning_sovereign_data_silos": "Analyse des silos de données souveraines pour les traces historiques...",
    "access_control": "Contrôle d'Accès",
    "sovereign_authority_matrix": "Matrice d'Autorité Souveraine",
    "manage_authority": "Gérer l'Autorité",
    "policy_compliance": "Conformité Politique",
    "gain": "Gain",
    "access_items": {
      "ministerial_access": "Accès Ministériel",
      "cfo_master_key": "Clé Maîtresse DAF",
      "compliance_audit": "Audit de Conformité",
      "third_party_hubs": "Hubs Tiers",
      "status_active": "Actif",
      "status_engaged": "Engagé",
      "status_nominal": "Nominal",
      "status_restricted": "Restreint"
    },
    "vault_v4": "Coffre_v4",
    "secure_sync": "SYNC_SÉCURISÉE",
    "aes_gcm": "AES-GCM-256",
    "key_count": "Nombre de Clés",
    "integrity": "Intégrité",
    "hsm_module_locked": "Module-HSM-Verrouillé",
    "sovereign_vault": "Coffre Souverain : {{id}}",
    "hsm_id": "ID_HSM : {{id}}_ALPHA",
    "integrity_verification": "Vérification d'Intégrité :",
    "enforced_active": "APPLIQUÉE_ACTIVE",
    "active_keys": "Clés Actives",
    "rotation_cycle": "Cycle de Rotation",
    "entropy_score": "Score d'Entropie",
    "access_load": "Charge d'Accès",
    "days_14": "14 Jours",
    "key_matrix_archive": "Archive Matrice de Clés",
    "export_report": "Exporter Rapport",
    "class": "Classe : {{type}}",
    "created": "Créé : {{date}}",
    "active": "Actif",
    "rotate_master_keys": "Pivoter Clés Maîtresses",
    "run_forensic_audit": "Lancer Audit Forensique",
    "sovereign_integrity_sealed": "Intégrité Souveraine Scellée",
    "charikaty_security_layer": "Couche de Sécurité Charikaty",
    "system_user": "SYSTÈME",
    "categories": {
      "ACCESS": "Accès",
      "TRANSACTION": "Transaction",
      "ENCRYPTION": "Chiffrement",
      "THREAT": "Menace",
      "SYSTEM": "Système"
    },
    "tx_types": {
      "OUTBOUND": "Sortant",
      "SWIFT": "SWIFT",
      "INTERNAL": "Interne"
    },
    "severities": {
      "low": "Faible",
      "medium": "Moyen",
      "high": "Élevé",
      "critical": "Critique"
    },
    "tx_statuses": {
      "approved": "Approuvé",
      "flagged": "Signalé",
      "blocked": "Bloqué"
    }
  },
  "databases": {
    "title": "Grille de Données Distribuée",
    "description": "Moteur de synchronisation de données de classe institutionnelle pour les clusters juridiques et financiers souverains. Cohérence atomique appliquée.",
    "system": "CORE_DATA_BACKBONE",
    "badge": "Grille Institutionnelle Active",
    "global_sync": "Sync Globale",
    "syncing": "Synchronisation...",
    "audit_lineage": "Lignage d'Audit",
    "metrics": {
      "distributed_traces": "Traces Distribuées",
      "aggregated_records": "Enregistrements Souverains Agrégés",
      "network_throughput": "Débit Réseau",
      "replication_stream": "Flux de Réplication Temps Réel",
      "hash_verification": "Vérification de Hash",
      "no_anomalies": "Aucune Anomalie Identifiée",
      "crypto_layer": "Couche Crypto",
      "module_encryption": "Chiffrement au Niveau du Module"
    },
    "clusters": {
      "legal": "Répertoire Juridique",
      "financial": "Grand Livre Financier",
      "operational": "Noyau Souverain",
      "offline": "Hors ligne",
      "active": "Module Actif",
      "standby": "En attente",
      "metrics_unavailable": "Métriques Indisponibles",
      "record_volume": "Volume d'Enregistrements",
      "integrity_level": "Niveau d'Intégrité",
      "alpha_7": "Cluster Souverain Alpha-7"
    },
    "topology": {
      "title": "Topologie du Maillage Souverain",
      "consensus": "Consensus Régional : Actif (Paxos-v4)",
      "latency": "Latence du Cluster",
      "global_sync_locked": "Sync Globale Verrouillée"
    },
    "explorer": {
      "placeholder": "SCAN DE L'INDEX MAÎTRE {{db}}...",
      "class_all": "Classe : Tous les Vecteurs",
      "no_records": "Aucun enregistrement identifié",
      "grid_empty": "La grille de données souveraine est vide pour cette sélection",
      "table": {
        "ref": "Réf. Enregistrement Maître",
        "entity": "Entité Souveraine / Actif",
        "class": "Classe de Sécurité",
        "integrity": "Vecteur d'Intégrité",
        "value": "Mappage de Valeur"
      }
    },
    "drawer": {
      "master_id": "ID Maître : {{id}}",
      "system_hash": "Hash Système :",
      "lifecycle": "Étape du Cycle de Vie",
      "asset_magnitude": "Magnitude de l'Actif",
      "classification": "Niveau de Classification",
      "security_manifest": "Manifeste de Sécurité",
      "manifest_desc": "Classification des Données Souveraines",
      "vector_class": "Classification du Vecteur",
      "access_protocol": "Protocole d'Accès",
      "metadata_matrix": "Matrice de Métadonnées Maître",
      "edit_params": "Modifier les Paramètres",
      "audit_view": "Vue Audit Complète",
      "version_lineage": "Lignage de Version",
      "secure_handshake": "Handshake Sécurisé",
      "integrity_seal": "Sceau d'Intégrité Actif",
      "aes_layer": "Multi-couche AES-256",
      "backbone": "Dorsale de Données Souveraine",
      "market_normalized": "Marché Normalisé",
      "sensitivity_level": "Niveau de Sensibilité"
    },
    "flow": {
      "step": "Étape {{num}}",
      "replicating": "Réplication..."
    },
    "node_modal": {
      "title": "Nœud de Cluster : {{id}}",
      "mesh_active": "Maillage {{region}} Actif",
      "metrics": {
        "cpu": "Charge Processeur",
        "io": "E/S Réseau",
        "storage": "Stockage Utilisé",
        "health": "Indice de Santé"
      },
      "thread_analytics": "Analytique des Threads Actifs",
      "nominal_flow": "Flux Nominal",
      "degraded": "Performance Dégradée",
      "reboot": "Redémarrer Cluster Sécurisé",
      "audit_storage": "Auditer le Stockage"
    },
    "audit_modal": {
      "title": "Audit du Lignage des Données",
      "traceability": "Traçabilité Complète Activée",
      "export": "Exporter l'Audit (PDF)"
    },
    "terminal": {
      "title": "SHELL_DE_DEBUG_SOUVERAIN",
      "init": "Initialisation de la connexion à la dorsale globale...",
      "auth": "Authentification : SUCCÈS (Souverain Root)",
      "status_logs": "--- JOURNAUX D'ÉTAT DU SYSTÈME ---"
    }
  },
  "connectivity": {
    "title": "Épine Dorsale Neurale",
    "description": "Surveillance de la grille souveraine, optimisation de la liaison montante haute densité et orchestration de la topologie inter-régionale.",
    "system": "BACKBONE_OPS",
    "actions": {
      "optimize": "Optimiser la Topologie"
    },
    "metrics": {
      "latency": "Vecteur de Latence",
      "latency_sla": "Cible SLA Ministérielle : < 15ms",
      "uplink": "Densité de Liaison Montante",
      "uplink_desc": "Handshakes de Pairs Simultanés",
      "coverage": "Couverture de la Grille",
      "coverage_desc": "Clusters Géo-Isolés",
      "uptime": "Temps de Disponibilité",
      "uptime_desc": "Vitalité du Système Central"
    },
    "tabs": {
      "nodes": "Infrastructure de Bord",
      "endpoints": "Points de Terminaison API"
    },
    "search": "Rechercher dans la matrice d'infrastructure...",
    "table": {
      "node_id": "Identifiant du Nœud",
      "region": "Région Géo",
      "health": "Vecteur de Santé",
      "telemetry": "Télémétrie",
      "perimeter": "Périmètre",
      "grid_load": "Charge de la Grille",
      "endpoint_path": "Chemin du Point de Terminaison",
      "method": "Méthode",
      "audit_status": "Statut d'Audit",
      "performance": "Performance P99",
      "total_calls": "{{count}} APPELS TOTAUX / HEURE",
      "error_rate": "Taux d'Erreur :",
      "nodes": "Nœuds"
    },
    "topology": {
      "title": "Topologie de Grille Dynamique",
      "subtitle": "Moteur d'Orchestration de Paquets de Grade Souverain",
      "validated": "Validé",
      "in_flight": "En Vol",
      "anycast": "Anycast",
      "global_wan": "WAN Global",
      "sovereign_gateway": "Passerelle Souveraine",
      "internal_clusters": "Clusters de Données Internes",
      "packet_audit": "Audit Approfondi des Paquets",
      "stealth_flow": "Flux Furtif Vérifié",
      "stealth_desc": "Handshakes mTLS & HSM avancés sur chaque point d'entrée.",
      "mapping": "Cartographie de la Topologie",
      "ai_grid": "Grille Optimisée par IA",
      "ai_grid_desc": "Reconfiguration dynamique des routes basée sur les modèles de charge neurale.",
      "resilience": "Résilience Anycast",
      "failover": "Basculement Multi-Couches",
      "failover_desc": "Géo-commutation sans temps d'arrêt avec dispersion actif-actif."
    },
    "vitality": {
      "title": "Vitalité de la Grille",
      "subtitle": "Matrice de Résilience Souveraine",
      "bgp": "Convergence BGP",
      "anycast_nodes": "Nœuds Anycast",
      "corruption": "Corruption de Paquets",
      "decay": "Indice de Dégradation de la Fibre",
      "aggregate_load": "Charge Globale de la Grille",
      "sync": "Sync Inter-Régionale",
      "synchronized": "SYNCHRONIZED",
      "analysis": "Analyse de la Topologie",
      "nominal_grid": "GRILLE_NOMINALE",
      "active_count": "{{count}}_ACTIF",
      "corruption_lim": "0,0001%_LIM",
      "decay_rate": "0,004%/AN",
      "util_suffix": "_UTIL"
    },
    "feed": {
      "title": "Flux Institutionnel",
      "subtitle": "Flux Forensique de l'Épine Dorsale en Direct",
      "streaming": "EN DIRECT",
      "source_node": "NŒUD_SOURCE :",
      "audit_verified": "Audit de Grille Neurale Vérifié v4.2"
    },
    "node_modal": {
      "protocol": "Protocole de Nœud :",
      "backbone_zone": "ZONE_ÉPINE_DORSALE",
      "latency": "Latence de Bord",
      "load_index": "Indice de Charge de la Grille",
      "health": "Santé du Réseau",
      "telemetry_title": "Télémétrie des Ressources Souveraines",
      "bandwidth": "Bande Passante de l'Épine Dorsale",
      "memory": "Mémoire du Cluster de Nœuds",
      "transport": "Secure Transport Protocols",
      "decommission": "Déclasser le Nœud",
      "initialize": "Initialiser le Nœud",
      "parametrics": "Paramétrie du Nœud",
      "network_layer": "Couche Réseau Souveraine",
      "protocols": {
        "tls": "TLS 1.3 (Souverain)",
        "http3": "HTTP/3 via QUIC",
        "waf": "WAF-L7 Institutionnel",
        "anycast": "IP de Maillage Anycast (Masquée)",
        "mtls": "Auth Mutuelle mTLS"
      },
      "identity_verified": "IDENTITÉ_mTLS_VÉRIFIÉE",
      "isolation_active": "ISOLATION_GÉOGRAPHIQUE_ACTIVE"
    },
    "status": {
      "healthy": "Sain",
      "online": "En Ligne",
      "offline": "Hors Ligne",
      "warning": "Avertissement",
      "critical": "Critique"
    }
  }
}